import { GAME_ID, REDUX_ACTIONS, QUESTIONS_PER_LEVEL } from '../../data/constants';

const initialState = {
  level: null, // start with null so logic in action for alternatin subSet doesn't get confused
  subSet: 1,
  progress: 0,
  questions: [],
  score: 0,
};

// handles data and actions related to current round

const roundReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // update state when gamestate data has been received
    case REDUX_ACTIONS.START_LEVEL:
    case REDUX_ACTIONS.START_HELP:
      return {
        ...state,
        ...payload,
        progress: 0,
        score: 0,
      };

    case REDUX_ACTIONS.INCREMENT_PROGRESS:
      return {
        ...state,
        progress: state.progress + 1,
      };

    case REDUX_ACTIONS.INCREMENT_SCORE:
      return {
        ...state,
        score: state.score + 1,
      };
    case REDUX_ACTIONS.QUICK_ROUND:
      return {
        ...state,
        progress: QUESTIONS_PER_LEVEL - 1,
        score: payload.pass ? QUESTIONS_PER_LEVEL : 0,
      };

    default:
      return state;
  }
};

export default roundReducer;
